import { motion } from 'framer-motion';
import { Download } from 'lucide-react';
import { EnquiryForm, AgentContact } from './EnquiryForm';
import { AGENT, PDF_URL, fadeUp } from './data';

export const EnquireSection = () => (
  <section id="enquire" className="py-20 md:py-28 bg-[#1a1e1a]" data-testid="enquire-section">
    <div className="max-w-5xl mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20">
        <motion.div {...fadeUp}>
          <p className="text-[#d6cdb4] text-sm tracking-[0.25em] uppercase mb-6">Enquire</p>
          <h2 className="text-3xl md:text-4xl text-white font-light mb-5">Arrange a viewing or ask a question</h2>
          <p className="text-white/80 mb-10">Private viewings are available now, including at short notice while you're in the area.</p>

          <div className="border-t border-white/15 pt-8 mb-10">
            <p className="text-[#d6cdb4] text-xs tracking-[0.2em] uppercase mb-5">Listing agent</p>
            <p className="text-white text-lg mb-1">{AGENT.name}</p>
            <p className="text-white/70 text-sm mb-4">{AGENT.company}</p>
            <AgentContact prefix="enquire" />
          </div>

          <div className="border-t border-white/15 pt-8" data-testid="download-section">
            <p className="text-[#d6cdb4] text-xs tracking-[0.2em] uppercase mb-5">Brochure</p>
            <a
              href={PDF_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="download-pdf-btn"
              className="inline-flex items-center gap-3 border border-[#c8bfa8]/70 text-[#e3dcc6] px-6 py-3 text-sm tracking-[0.12em] uppercase hover:bg-[#c8bfa8] hover:text-[#1a1e1a] transition-colors"
            >
              <Download size={16} />
              Download project booklet (PDF)
            </a>
          </div>
        </motion.div>

        <motion.div {...fadeUp}>
          <EnquiryForm prefix="enquire" source="the-126-house-enquiry" showInterest submitLabel="Send enquiry" />
        </motion.div>
      </div>
    </div>
  </section>
);
